const Location = window.location;
const History = window.history;
const URI = window.location.href;
const origin = window.location.origin;
const pathname = window.location.pathname;

var variables = {
  $container: ".collection-listing .product-list",
  $productMyfilter: ".product-my-filter",
  $loading: ".loading-filter",
};
var originProducts;

async function initProduct() {
  const response = await $.getJSON(origin + pathname + "/products.json?limit=500");
  originProducts = response.products;
}

function onChangeSelect(self) {
  const type = self.getAttribute("data-type");
  const parent = self.closest('.custom-options');
  const values = parent ? parent.querySelectorAll('input.custom-option:checked') : []
  const stringVal = Array.from(values).map(ele => ele.getAttribute("data-value")).join('+')
  const currentHref = window.location.href;
  const getLengthChecked = parent.querySelectorAll('input.custom-option:checked');
  const parentCount = self.closest('.select');
  let elCountFilter = parentCount.querySelector('.count_filter');
  elCountFilter.innerHTML = "(" + getLengthChecked.length + ")";
  $('.new-filter').removeClass('mobile-open');
  if (stringVal) {
    const urlPushState = addOrUpdateUrlParam(currentHref, type, stringVal);
    History.pushState(null, "", urlPushState);
    const params = getParamsFromUrl(urlPushState);
    filterProduct(params);
  }else{
    const urlPushState = removeURLParameter(currentHref, type);
    const params = getParamsFromUrl(urlPushState);
    filterProduct(params);
    History.pushState(null, "", urlPushState);
    window.location.reload();
  }
}

function toggleCheckbox(self) {
  const type = self.getAttribute("data-type");
  const value = self.getAttribute("data-value");
  const checked = self.checked;
  const currentHref = window.location.href;
  if (checked) {
    const urlPushState = addOrUpdateUrlParam(currentHref, type, value);
    History.pushState(null, "", urlPushState);
    const params = getParamsFromUrl(urlPushState);
    filterProduct(params);
    $('.new-filter').removeClass('mobile-open');
  } else {
    const urlPushState = removeURLParameter(currentHref, type);
    const params = getParamsFromUrl(urlPushState);
    filterProduct(params);
    History.pushState(null, "", urlPushState);
    $('.new-filter').removeClass('mobile-open');
  }
}
function sortSelect(self) {
  const value = self.value;
  const type = "sortBy";
  const currentHref = window.location.href;
  const urlPushState = addOrUpdateUrlParam(currentHref, type, value);
  History.pushState(null, "", urlPushState);
  const params = getParamsFromUrl(urlPushState);
  filterProduct(params);
}
function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
const processChange = debounce((self) => priceChange(self));

function priceChange(self) {
  const type = self.getAttribute("type");
  const value = self.value;
  if (value) {
    const currentHref = window.location.href;
    const urlPushState = addOrUpdateUrlParam(currentHref, type, value);
    History.pushState(null, "", urlPushState);
    const params = getParamsFromUrl(urlPushState);
    filterProduct(params);
  }
}

async function filterProduct(params) {
  await initProduct();
  const $color = params["color"] || null;
  const $size = params["size"] || null;
  const $vendor = params["vendor"] || null;
  const $gender = params["gender"] || null;
  const $bodyFit = params["bodyFit"] || null;
  const $brand = params["brand"] || null;
  const $country = params["country"] || null;
  const $feature = params["feature"] || null;
  const $certification = params["certification"] || null;
  const $fabricType = params["fabricType"] || null;
  const $minPrice = params["minPrice"];
  const $maxPrice = params["maxPrice"];
  const $stock = params["stock"];
  const $nextDelivery = params["delivery"];
  const $sortBy = params["sortBy"];

  if ($color || $size) {
    const productAfterFilter = [];
    for (product of originProducts) {
      for (variant of product.variants) {
        if ((!$color
          || variant.option1 && $color.split('+').map(x => x.toLowerCase()).includes(variant.option1.toLowerCase())
        ) && (
          !$size
          || variant.option2 && $size.split('+').map(x => x.replace(' ','-').toUpperCase()).includes(variant.option2.toUpperCase())
        )) {
          const cp = { ...product, variants: [variant] };
          const check = productAfterFilter.find((p) => p.id === product.id && p.variants[0].option1 === variant.option1);
          if (!check) {
            productAfterFilter.push(cp);
          }
        }
      }
    }
    originProducts = productAfterFilter;
  }

  if ($vendor) {
    const products = originProducts.filter((product) =>
      (product.vendor.toLowerCase()).replaceAll(' ','-').includes($vendor.toLowerCase())
    );
    originProducts = products;
  }
  if ($gender) {
    const products = originProducts.filter((product) =>
      $gender.split('+').map(tag => tag.toLowerCase()).find(val => product.tags.map(tag => tag.toLowerCase()).includes(val))
    );
    originProducts = products;
  }

  if ($bodyFit) {
    const products = originProducts.filter((product) => {
      if($bodyFit.split('+').map(tag => tag.toLowerCase()).find(val => product.tags.map(tag => tag.toLowerCase()).includes(val))) return product;
    });
    originProducts = products;
  }

  if ($brand) {
    const products = originProducts.filter((product) =>
      $brand.split('+').map(tag => tag.toLowerCase()).find(val => product.tags.map(tag => tag.toLowerCase()).includes(val))
    );
    originProducts = products;
  }

  if ($country) {
    const products = originProducts.filter((product) =>
      $country.split('+').map(tag => tag.toLowerCase()).find(val => product.tags.map(tag => tag.toLowerCase()).includes(val))
    );
    originProducts = products;
  }

  if ($feature) {
    const products = originProducts.filter((product) =>
      $feature.split('+').map(tag => tag.toLowerCase()).find(val => product.tags.map(tag => tag.toLowerCase()).includes(val))
    );
    originProducts = products;
  }

  if ($certification) {
    const products = originProducts.filter((product) =>
      $certification.split('+').map(tag => tag.toLowerCase()).find(val => product.tags.map(tag => tag.toLowerCase()).includes(val))
    );
    originProducts = products;
  }

  if ($fabricType) {
    const products = originProducts.filter((product) =>
      $fabricType.split('+').map(tag => tag.toLowerCase()).find(val => product.tags.map(tag => tag.toLowerCase()).includes(val))
    );
    originProducts = products;
  }

  if ($minPrice) {
    const products = [];
    for (product of originProducts) {
      let ok = false;
      for (variant of product.variants) {
        if (
          Number(variant.price) >= $minPrice
        ) {
          ok = true;
          break;
        }
      }
      if (ok) products.push(product);
    }
    originProducts = products;
  }
  if ($maxPrice) {
    const products = [];
    for (product of originProducts) {
      let ok = false;
      for (variant of product.variants) {
        if (
          Number(variant.price) <= $maxPrice
        ) {
          ok = true;
          break;
        }
      }
      if (ok) products.push(product);
    }
    originProducts = products;
  }
  if ($stock) {
    const products = [];
    for (product of originProducts) {
      let ok = false;
      for (variant of product.variants) {
        if (variant.available) {
          ok = true;
          break;
        }
      }
      if (ok) products.push(product);
    }
    originProducts = products;
  }

  if ($nextDelivery) {
    const products = originProducts.filter((product) =>
      product.tags.includes($nextDelivery)
    );
    originProducts = products;
  }
  if ($sortBy === "a-z") {
    originProducts.sort((a, b) => a.title.localeCompare(b.title));
  }
  if ($sortBy === "z-a") {
    originProducts.sort((a, b) => b.title.localeCompare(a.title));
  }
  if ($sortBy === "price-low-high") {
    originProducts.sort((a, b) => a.variants[0].price - b.variants[0].price);
  }
  if ($sortBy === "price-high-low") {
    originProducts.sort((a, b) => b.variants[0].price - a.variants[0].price);
  }
  if ($sortBy === "date-new-old") {
    originProducts.sort((a, b) => {
      const aDate = new Date(a.published_at);
      const bDate = new Date(b.published_at);
      return bDate - aDate;
    });
  }
  if ($sortBy === "date-old-new") {
    originProducts.sort((a, b) => {
      const aDate = new Date(a.published_at);
      const bDate = new Date(b.published_at);
      return aDate - bDate;
    });
  }
  renderListProduct(originProducts);
  reRenderFilter();
  countFilter();
}

async function renderListProduct(products) {
  const container = document.querySelector(variables.$container);
  const nodeLoading = document.createElement("div");
  const nodeEmpty =
    "<div class='text-center' style='flex: 1'>No products found</div>";
  nodeLoading.className = "loading-filter";
  container.appendChild(nodeLoading);
  let productList = "";
  if (products.length == 0) {
    productList += nodeEmpty;
  }
  for (product of products) {
    productList += await renderProductItem(product);
  }
  setTimeout(() => {
    const loading = document.querySelector(variables.$loading);
    loading.remove();
    container.innerHTML = productList;
    getCount();
  }, 1000);
}

function reRenderFilter(){
var tagAll = [],
productAll = [],
variantColor = [],
variantSize = [],
colorAll = [],
sizeAll = [];
for(getProducts of originProducts){
  for(getTags of getProducts.tags){
      tagAll.push(getTags.toLowerCase());
  }
  for(getOptions of getProducts.options){
    if(getOptions.name == "Colour"){
      for(getColor of getOptions.values){
      	variantColor.push(getColor)
        colorAll = ([...new Set(variantColor)]).map(s => s.replace(' ','-').toLowerCase())
      }
    }
    if(getOptions.name == "Size"){
      for(getSize of getOptions.values){
      	variantSize.push(getSize)
        sizeAll = ([...new Set(variantSize)]).map(s => s.replace(' ','-').toLowerCase())
      }
    }
  }
}

// var  sizeAllLowerCase = sizeAll.filter(Boolean).map(s => s.toLowerCase())
// var getSelect = document.querySelectorAll('.select-wrapper');
// for(let i = 0; i < getSelect.length; i++){
//   let getTags = getSelect[i].querySelectorAll('.custom-option');
//   let countGetTag = 0;
//   for(let y = 0; y < getTags.length; y++){
//     let textTag = getTags[y].getAttribute('data-value').toLocaleLowerCase();
//     if(!tagAll.includes(textTag) && !colorAll.includes(textTag) && !sizeAllLowerCase.includes(textTag)){
//       getTags[y].parentElement.style.display = 'none';
//       countGetTag += 1;
//     }
//   }
//   if(countGetTag >= getTags.length && getTags.length){
//     getSelect[i].style.display = 'none';
//   }
// }
}

async function jsonItems(product) {
  if(!designModeFilter){
    let response = await fetch(
      `${storeURL}/products/${product.handle}?view=json`
    );
    const resText = await response.text();
    const data = JSON.parse(resText.split('<div')[0].trim());
    return data?.dataJson;
  }
}

async function renderProductItem(product) {
  if(!designModeFilter){
    const variants = product.variants;
    const uniqueVariants = [];
    let variantHTML = "";
    const colorOptions = await jsonItems(product);

    for (let i = 0; i < variants.length; i++) {
      const check = uniqueVariants.some(
        (item) => item.option1 === variants[i].option1
      );
      if (!check && variants[i].option1 !== "Default Title") {
        uniqueVariants.push(variants[i]);
      }
    }

    for (let i = 0; i < uniqueVariants.length; i++) {
      const variant = uniqueVariants[i];
      const sizeItems = product?.options[1]?.values || '';
      let sizeString = '', sizeItem = '';

      if(!!sizeItems) {
        sizeString = sizeItems.toString();
        sizeItem = sizeString.replaceAll(",", "   ").replaceAll("-"," ");
      }

      const optionColorCurrent = colorOptions[i] || {};
      let colorOptionHTML = "";
      for (const [key, value] of Object.entries(optionColorCurrent)) {
        colorOptionHTML += `
        <span
          class="product-block-options__item lazyloaded"
          data-option-item="${key}"
          data-bgset="${value}"
          style="background-image: url(${value});"
        >
          <span class="product-block-options__item__text">${key}</span>
          <picture class="" style="display: none;">
              <source
                  data-srcset="${value}"
                  sizes="143px"
                  srcset="${value}"
              />
              <img alt="" class="lazyautosizes lazyloaded" data-sizes="auto" data-parent-fit="cover" sizes="143px" />
          </picture>
        </span>`;
      }

      variantHTML += `
      <div class="col-sm-6 col-6 col-lg-4">
          <div class="product-block product-item product-my-filter">
            <a href="/products/${product.handle}?variant=${variant.id}">
              <img src="${variant?.featured_image?.src || "https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif"}" />
            </a>
            <div class="product-vendor">${product.vendor}</div>
            <a class="product-title" href="/products/${product.handle}?variant=${variant.id}">${product.title}</a>
            <span class="product-price">£ ${variant.price}</span>
            <div class="product-block-options product-block-options--swatch">
              <div class="product-block-options__inner">
                ${colorOptionHTML}
              </div>
            </div>
            <div class="product-block-options" data-option-name="Size">
            <div class="product-block-options__inner">
                <span class="product-block-options__item" data-option-item="size"><span class="product-block-options__item__text" style="letter-spacing: 1px;">${sizeItem}</span></span>
            </div>
          </div>
        </div>
      </div>`;
    }
    return variantHTML;
  }
}

function getCount() {
  const elChild = document.getElementsByClassName("product-item");
  const countProduct = document.getElementById("count-product");
  countProduct.innerHTML = elChild.length + " product displayed";
}

function addOrUpdateUrlParam(uri, paramKey, paramVal) {
  var re = new RegExp("([?&])" + paramKey + "=[^&#]*", "i");
  if (re.test(uri)) {
    uri = uri.replace(re, "$1" + paramKey + "=" + paramVal);
  } else {
    var separator = /\?/.test(uri) ? "&" : "?";
    uri = uri + separator + paramKey + "=" + paramVal;
  }
  return uri;
}

function removeURLParameter(url, parameter) {
  var urlparts = url.split("?");
  if (urlparts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + "=";
    var pars = urlparts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0; ) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
  }
  return url;
}

function getParamsFromUrl(url) {
  var params = {};
  var parser = document.createElement("a");
  parser.href = url;
  var query = parser.search.substring(1);
  if (query) {
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
  }
  return params;
}

document.addEventListener("DOMContentLoaded", async function () {
  const params = getParamsFromUrl(URI);
  if (Object.keys(params).length > 0) {
    await initProduct();
    filterProduct(params);
  } else {
    getCount();
  }
  // Mapping default value from url
  const colour = params["color"] || null;
  const size = params["size"] || null;
  const gender = params["gender"] || null;
  const bodyFit = params["bodyFit"] || null;
  const brand = params["brand"] || null;
  const country = params["country"] || null;
  const feature = params["feature"] || null;
  const certification = params["certification"] || null;
  const fabricType = params["fabricType"] || null;
  const minPrice = params["minPrice"];
  const maxPrice = params["maxPrice"];
  const stock = params["stock"];
  const delivery = params["delivery"];
  const sortBy = params["sortBy"];

  if (colour) {
    const parent = document.querySelector("#select-color");
    const options = parent.querySelectorAll(".custom-option");
    options.forEach(function(option) {
      if (colour.split('+').map(tag => tag.toLowerCase()).includes(option.getAttribute("data-value"))) {
        option.checked = true;
      }
    })
  }
  if (size) {
    const parent = document.querySelector("#select-size");
    const options = parent.querySelectorAll(".custom-option");
    options.forEach(function(option) {
      if (size.split('+').map(tag => tag.toLowerCase()).includes(option.getAttribute("data-value"))) {
        option.checked = true;
      }
    })
  }
  if (gender) {
    const parent = document.querySelector("#select-gender");
    const options = parent.querySelectorAll(".custom-option");
    options.forEach(function(option) {
      if (gender.split('+').map(tag => tag.toLowerCase()).includes(option.getAttribute("data-value"))) {
        option.checked = true;
      }
    })
  }
  if (bodyFit) {
    const parent = document.querySelector("#select-bodyFit");
    const options = parent.querySelectorAll(".custom-option");
    options.forEach(function(option) {
      if (bodyFit.split('+').map(tag => tag.toLowerCase()).includes(option.getAttribute("data-value"))) {
        option.checked = true;
      }
    })
  }
  if (brand) {
    const parent = document.querySelector("#select-brand");
    const options = parent.querySelectorAll(".custom-option");
    options.forEach(function(option) {
      if (brand.split('+').map(tag => tag.toLowerCase()).includes(option.getAttribute("data-value"))) {
        option.checked = true;
      }
    })
  }
  if (country) {
    const parent = document.querySelector("#select-country");
    const options = parent.querySelectorAll(".custom-option");
    options.forEach(function(option) {
      if (country.split('+').map(tag => tag.toLowerCase()).includes(option.getAttribute("data-value"))) {
        option.checked = true;
      }
    })
  }
  if (certification) {
    const parent = document.querySelector("#select-certifications");
    const options = parent.querySelectorAll(".custom-option");
    options.forEach(function(option) {
      if (certification.split('+').map(tag => tag.toLowerCase()).includes(option.getAttribute("data-value"))) {
        option.checked = true;
      }
    })
  }
  if (fabricType) {
    const parent = document.querySelector("#select-fabricTypes");
    const options = parent.querySelectorAll(".custom-option");
    options.forEach(function(option) {
      if (fabricType.split('+').map(tag => tag.toLowerCase()).includes(option.getAttribute("data-value"))) {
        option.checked = true;
      }
    })
  }
  if (feature) {
    const parent = document.querySelector("#select-features");
    const options = parent.querySelectorAll(".custom-option");
    options.forEach(function(option) {
      if (feature.split('+').map(tag => tag.toLowerCase()).includes(option.getAttribute("data-value"))) {
        option.checked = true;
      }
    })
  }
  if (minPrice) {
    const parent = document.querySelector("#select-price");
    parent.querySelector("#CCPriceRangeMin").value = minPrice;
    parent
      .querySelector(".cc-price-range__control--min")
      .setAttribute("aria-valuenow", minPrice);
    parent.querySelector(".cc-price-range__control--min").style.left =
      minPrice + "%";
  }
  if (maxPrice) {
    const parent = document.querySelector("#select-price");
    parent.querySelector("#CCPriceRangeMax").value = maxPrice;
    parent
      .querySelector(".cc-price-range__control--max")
      .setAttribute("aria-valuenow", maxPrice);
    parent.querySelector(".cc-price-range__control--max").style.left =
      maxPrice + "%";
  }

  if (delivery) {
    const checkBoxDelivery = document.querySelector("#checkbox1");
    const checkboxValueData = checkBoxDelivery.getAttribute("data-value");
    if (delivery == checkboxValueData) {
      checkBoxDelivery.checked = true;
    }
  }

  if (stock) {
    const checkBoxStock = document.querySelector("#checkbox2");
    const checkboxValueData = checkBoxStock.getAttribute("data-value");
    if (stock == checkboxValueData) {
      checkBoxStock.checked = true;
    }
  }

  if (sortBy) {
    const parentSort = document.querySelector("#sort-by");
    const options = parentSort.querySelectorAll("option");
    for (option of options) {
      if (option.getAttribute("value") == sortBy) {
        option.setAttribute("selected", "selected");
        break;
      }
    }
  }
});

function clearFilter(){
  const currentHref = window.location.href;
  let urlPushState;
  if(currentHref.includes('vendor')){
    urlPushState = currentHref.split('&')[0];
  }else{
    urlPushState = currentHref.split('?')[0];
  }
  History.pushState(null, "", urlPushState);
  window.location.reload();
  countFilter();
}

function countFilter(){
  const options = document.querySelectorAll(".custom-option");
  const clearFilter = document.querySelector(".clear-filter");
  let checkedInput = false;
  for(let i = 0; i < options.length; i++){
    checkedInput = options[i].checked == true;
    if(checkedInput){
      clearFilter.style.display = "block";
      break;
    }else{
      clearFilter.style.display = "none";
    }
  }
}

